export default __webpack_public_path__ + "static/stationWagon-80f3108fc4cf97357267a8bf205b820f.svg";